import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import CompetitionDrawer from "../../components/atoms/drawer/CompetitionDrawer";
import { useTournamentDetail } from "../../@apis/hooks/useTournament";
import { getQueryClient } from "../../@apis/queryClient";
// 접수 대기열 배포 보류 — 되살릴 때 아래 주석을 함께 해제한다
// import { useCallback, useEffect } from "react";
// import { useApplyQueueGate } from "../../hooks/useApplyQueueGate";
// import { useModalStore } from "../../lib/store/useModalStore";

export default function CompetitionApply() {
  const { id } = useParams();
  const navigate = useNavigate();
  // const { openModal } = useModalStore();

  const { data: tournamentInfo } = useQuery({
    ...useTournamentDetail(id as string),
    enabled: !!id,
  });

  // const exitToDetail = useCallback(
  //   (title: string, content?: string) => {
  //     openModal("ALERT_DIALOG", { title, content });
  //     navigate(-1);
  //   },
  //   [navigate, openModal],
  // );

  // 입장 판정은 대회 상세에서 끝났다. 여기서는 자격이 살아 있는지 확인만 하고,
  // 새로고침이나 직접 진입처럼 자격이 없으면 상세로 돌려보낸다.
  // const { gate, remainingSeconds, verify } = useApplyQueueGate({
  //   id,
  //   onExit: exitToDetail,
  // });

  // useEffect(() => {
  //   if (id) verify();
  // }, [id, verify]);

  // 대기는 상세 화면에서만 한다 — 여기서 대기 상태가 되면 상세로 돌려보낸다
  // useEffect(() => {
  //   if (gate === "waiting") {
  //     exitToDetail("접수 순서를 기다려야 해요", "접수하기를 다시 눌러 주세요.");
  //   }
  // }, [gate, exitToDetail]);

  const { data, success } = tournamentInfo || {};
  if (!success || !data) return null;

  // 입장 자격이 확인된 뒤에만 접수 화면을 그린다
  // if (gate !== "pass") return null;

  return (
    <>
      {/* 접수 대기열 배포 보류 — 입장 잔여 시간 표시
      {remainingSeconds != null && (
        <div
          className={`fixed top-3 left-1/2 -translate-x-1/2 z-[9999] rounded-full px-4 py-1.5 text-xs font-bold text-white ${
            remainingSeconds <= 60 ? "bg-red-500/90" : "bg-black/80"
          }`}
        >
          접수 가능 시간 {Math.floor(remainingSeconds / 60)}:
          {String(remainingSeconds % 60).padStart(2, "0")}
        </div>
      )} */}
      <CompetitionDrawer
        id={id as string}
        type="add"
        open
        item={data}
        onClose={() => {
          getQueryClient().invalidateQueries({
            queryKey: ["tournament-detail", id],
          });
          navigate(-1);
        }}
        calendarList={data.tournamentInfo.calendarList || []}
      />
    </>
  );
}
